import { Context, createContext, Dispatch, SetStateAction } from 'react';

import { Page } from 'core/model';

type PageContextArray = [Page, Dispatch<SetStateAction<Page>>];

const FwPageContext: Context<PageContextArray> = createContext(undefined);

export { FwPageContext };
